export const phoneNumberLength: number = 6;
export const minOperatorCodeLength: number = 2;